import { render, staticRenderFns } from "./ModalEditCentre.vue?vue&type=template&id=2f447cdc&"
import script from "./ModalEditCentre.vue?vue&type=script&lang=js&"
export * from "./ModalEditCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports